import { createSlice } from '@reduxjs/toolkit';
import type {  ActivityLogState,  JobDetailsState } from 'src/types/jobs';
import reducers from 'src/redux/jobs/reducers';
import extraReducers from 'src/redux/jobs/extra-reducers';

export const initialState: JobDetailsState = {
  slideOut: {
    openedJobDetailsId: '',
    type: '',
    jobId: '',
    srId: '',
    activeTab: '',
    hasInitialActivityLogApiTriggered: false,
    needToRefetch: false,
  },
  isLoading: true,
  isActivityLogLoading: true,
  isFetchingNotes: false,
  isFetchingMessages: true,
  isFetchingMessageThreads: false,
  updatingResidentCaused: false,
  data: {} as JobDetailsState['data'],
  activityLog: {} as ActivityLogState,
  messages: {},
  flagRollup: null,
  isFlagRollupLoading: false,
};

const jobDetails = createSlice({
  name: 'jobDetails',
  initialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  openJobDetailsSlideOut,
  clearSlideOut,
  updateSlideOut,
  clearJobDetails,
  updateSlideOutData,
  updateActivityLog,
  updateReduxMessageState,
  clearMessages,
  updateMessage,
  updateMessageToReadOrUnread,
  updateMessageOnPusher,
  clearMessageConfig,
  updateWatcherList,
  updatePropertyEscalation,
  updateResidentCausedFromPusher,
} = jobDetails.actions;

export default jobDetails.reducer;
